var MDB = window.MDB || {};
MDB.DNX = MDB.DNX || {};
MDB.DNX.LabelingAnalysis = MDB.DNX.LabelingAnalysis || {};

(function($){
    $.extend(MDB.DNX.LabelingAnalysis, {
        SentenceQuestions: {
            Speaker: 1,
            Gender: 2,
            SentimentText: 3,
            EmotionText: 4,
            EmotionIntensityText: 5,
            JourneyStep: 6,
            
            AttitudeAudio: 27,
            SentimentAudio: 13,
            EmotionAudio: 14,
            EmotionIntensityAudio: 15,
            
            Remarks: 17,

            SentimentTextCustomer: 20,
            EmotionTextCustomer: 21,
            EmotionIntensityTextCustomer: 22,
            JourneyStepCustomer: 23,

            AttitudeAudioCustomer: 28,            
            SentimentAudioCustomer: 24,
            EmotionAudioCustomer: 25,
            EmotionIntensityAudioCustomer: 26
        },
        PersonalityQuestions: {
            PersonalityOpenness: 7,
            PersonalityAgreeableness: 8,
            PersonalityConscientiousness: 9,
            PersonalityNeuroticism: 10,
            PersonalityExtroversion: 11,
            PersonalitySure: 12
        },
        QuestionDisplayTypes: {
            Textbox: 'Textbox',
            Radio: 'RadioButton',
            Checkbox: 'Checkbox',
            Dropdown: 'Dropdown',
            Slider: 'Slider'
        },
        
        SnowplowTrackingEnabled: false,
        SnowplowEventSchema: 'iglu:nl.datanext.dnx/labelinginput/jsonschema/1-0-0',
        
        //1 minute
        AutoSaveInterval: 60000,
        AutoSaveEndpoint: '/LabelingAnalysis/AutoSaveAnalysisProgress',
        AutoSaveIntervalId: undefined,
        IsAutoSaving: false,
        AutoSaveProm: null,
        
        SpeakerBothAnswer: 'b',
        DisabledValue: '-999',
        
        SentenceSliderMin: 0,
        SentenceSliderMax: 100,
        
        PersonalityTraitSliderMin: 1,
        PersonalityTraitSliderMax: 5,
        
        boot: function(){
            //Our SentenceQuestions need to be initialized prior to us being able to use them
            //thus we need to wait for our boot() func to be invoked
            MDB.DNX.LabelingAnalysis.SentenceIntensitySliderCombos = [
                { Dropdown: MDB.DNX.LabelingAnalysis.SentenceQuestions.EmotionText, Slider: MDB.DNX.LabelingAnalysis.SentenceQuestions.EmotionIntensityText },
                { Dropdown: MDB.DNX.LabelingAnalysis.SentenceQuestions.EmotionAudio, Slider: MDB.DNX.LabelingAnalysis.SentenceQuestions.EmotionIntensityAudio },
                { Dropdown: MDB.DNX.LabelingAnalysis.SentenceQuestions.EmotionTextCustomer, Slider: MDB.DNX.LabelingAnalysis.SentenceQuestions.EmotionIntensityTextCustomer },
                { Dropdown: MDB.DNX.LabelingAnalysis.SentenceQuestions.EmotionAudioCustomer, Slider: MDB.DNX.LabelingAnalysis.SentenceQuestions.EmotionIntensityAudioCustomer }
            ];
            
            var isReadOnly = MDB.DNX.LabelingAnalysis.IsMarkedReadOnly();
            
            var audioPlayers = $('.audio-player')
                , callAudioPlayerContainer = $('#call-audio-player-container');

            var intensitySliderIds = MDB.DNX.LabelingAnalysis.SentenceIntensitySliderCombos.map(function(combo){
                return combo.Slider;
            });
            
            //We can't initialise our sliders all at the same time
            //our sentences range from 0 to 100, while our call sliders range from 1 to 5
            //Dropdown/slider combos are special cases and have their own render function
            var allSentenceSliders = $('.sentence-analysis [data-display-type="' + MDB.DNX.LabelingAnalysis.QuestionDisplayTypes.Slider + '"]');
            var regularSentenceSliders = allSentenceSliders.filter(function(){ return intensitySliderIds.indexOf(parseInt(this.dataset['questionId'])) === -1; });
            var callSliders = $('.call-analysis [data-display-type="' + MDB.DNX.LabelingAnalysis.QuestionDisplayTypes.Slider + '"]');
            
            //A bounds tooltip either contains a single string, or an array of strings as content
            //when an array is provided, we want to build a list element
            //the actual content should never be rendered as is however (in case it is HTML)
            var boundsTooltips = $('.bounds-tooltip');
            
            var hideSentencesSwitch = $('#hide-sentences-switch');
            
            var removeTranscriptCheckboxes = $('[name$="RemoveTranscript"]')
                , sentenceCompleteCheckboxes = $('[name$="Completed"]')
                , sentenceTranscriptUnsureCheckboxes = $('[name$="UnsureOfTranscript"]')
                , personalityTraitUnknownCheckboxes = $('.personality-trait-question [name$="Unknown"]');
            
            var dropdowns = $('[data-display-type="' + MDB.DNX.LabelingAnalysis.QuestionDisplayTypes.Dropdown + '"]');

            var speakerRadioButtons = $('.sentence-analysis [data-question-id="' + MDB.DNX.LabelingAnalysis.SentenceQuestions.Speaker + '"]');

            //The submit button clicked determines which endpoint our form will be posted to
            $('.labeling-analysis-submit-btn').on('click', function(e) {
                MDB.DNX.LabelingAnalysis.DisableAutoSave();
                
                //Saving can take a few seconds
                //prevent any further tampering with the form while the user waits
                MDB.UI.Loader.show();

                var $this = $(this);

                //Wait for our current autoSave to finish -> re-trigger our click event
                //no more autoSaves should be able to happen after invoking DisableAutoSave(...) 
                if(MDB.DNX.LabelingAnalysis.IsAutoSaving){
                    e.preventDefault();
                    MDB.DNX.LabelingAnalysis.AutoSaveProm.always(function(){
                        $this.trigger('click');
                    });
                    
                    return;
                }
                
                var btnTarget = $this.data('target');
                MDB.DNX.LabelingAnalysis.SetFormTarget(btnTarget);
            });
            
            MDB.createAudioPlayer(audioPlayers);
            
            MDB.DNX.LabelingAnalysis.RenderSentenceSliders(regularSentenceSliders);
            MDB.DNX.LabelingAnalysis.RenderPersonalityTraitSliders(callSliders);

            MDB.DNX.LabelingAnalysis.SentenceIntensitySliderCombos.forEach(function(combo){
                var sliders = allSentenceSliders.filter('[data-question-id="' + combo.Slider +'"]');
                MDB.DNX.LabelingAnalysis.RenderIntensitySliders(sliders, combo); 
            });
            
            //All controls need to be ready prior to being able to disable them
            //MDB.DNX.LabelingAnalysis.ToggleSentenceBlock(removeTranscriptCheckboxes.filter(':checked'), false);
            
            MDB.DNX.LabelingAnalysis.ToggleSentenceCompletion(sentenceCompleteCheckboxes.filter(':checked'), true);
            MDB.DNX.LabelingAnalysis.ToggleSentenceTranscriptUnsure(sentenceTranscriptUnsureCheckboxes.filter(':checked'), true);
            MDB.DNX.LabelingAnalysis.ToggleSliders(
                personalityTraitUnknownCheckboxes.filter(':checked').closest('.personality-trait-question'),
                false  
            );
            MDB.DNX.LabelingAnalysis.ToggleCustomerQuestionBlocks(
                speakerRadioButtons.filter(':checked[value="' + MDB.DNX.LabelingAnalysis.SpeakerBothAnswer + '"]'), 
                true
            );

            MDB.DNX.LabelingAnalysis.RenderBoundsTooltips(boundsTooltips);

            if(!isReadOnly){
                //removeTranscriptCheckboxes.on('change', function(){
                //    var $this = $(this)
                //        , enabled = !$this.is(':checked');

                //    MDB.DNX.LabelingAnalysis.ToggleSentenceBlock($this, enabled);
                //});
                
                speakerRadioButtons.on('change', function(){
                    var $this = $(this)
                        , shouldDisplayCustomerQuestions = $this.val() === MDB.DNX.LabelingAnalysis.SpeakerBothAnswer;
                    
                    MDB.DNX.LabelingAnalysis.ToggleCustomerQuestionBlocks($this, shouldDisplayCustomerQuestions);
                });

                sentenceCompleteCheckboxes.on('change', function(){
                    var $this = $(this)
                        , completed = $this.is(':checked');

                    MDB.DNX.LabelingAnalysis.ToggleSentenceCompletion($this, completed);
                });

                sentenceTranscriptUnsureCheckboxes.on('change', function(){
                    var $this = $(this)
                        , enabled = $this.is(':checked');

                    MDB.DNX.LabelingAnalysis.ToggleSentenceTranscriptUnsure($this, enabled);
                });

                personalityTraitUnknownCheckboxes.on('change', function(){
                    var $this = $(this)
                        , traitQuestion = $(this).closest('.personality-trait-question')
                        , enabled = !$this.is(':checked');

                    MDB.DNX.LabelingAnalysis.ToggleSliders(traitQuestion, enabled);
                });

                MDB.DNX.LabelingAnalysis.SentenceIntensitySliderCombos.forEach(function(combo){
                    $('[data-question-id="' + combo.Dropdown + '"]').on('change', function() {
                        //Re-render current block slider on change, icons will probably have changed
                        MDB.DNX.LabelingAnalysis.RenderIntensitySliders(this, combo);
                    })
                });

                MDB.DNX.LabelingAnalysis.AddTrackingToDropdowns(dropdowns);

                //Enable tracking once everything is initialized
                MDB.DNX.LabelingAnalysis.SnowplowTrackingEnabled = true;
            }
            
            MDB.DNX.LabelingAnalysis.RenderSentenceCollapseSwitch(hideSentencesSwitch);
            
            if(isReadOnly){
                MDB.DNX.LabelingAnalysis.ToggleSliders(allSentenceSliders, false);

                $('.labeling-question input, .labeling-question textarea, .labeling-question select')
                    .attr('disabled', 'disabled');
            }
            
            callAudioPlayerContainer.sticky({
                topSpacing: $('.main-header').height(), 
                zIndex: 1
            });
            
            if(!isReadOnly){
                MDB.DNX.LabelingAnalysis.InitializeAutoSave();
            }
        },
        IsMarkedReadOnly: function(){
            return MDB.DNX.LabelingAnalysis.GetFormSelector().hasClass('readonly');
        },
        DisableAutoSave: function(){
            //Does not cancel the current running autoSave if one is happening
            //simply cancels the next scheduled save
            clearTimeout(MDB.DNX.LabelingAnalysis.AutoSaveIntervalId);
        },
        InitializeAutoSave: function(){
            var getQuestions = function(){ return $('.labeling-question'); };
            var getDirtyQuestions = function(){ return getQuestions().filter('.dirty'); };
            
            //Watch our input elements for changes
            //when no change has occurred since our last save
            //we can skip our autosave routine
            getQuestions().on('change', function(){
                $(this).addClass('dirty');
            });
            
            //Default to an already resolved promise
            //this way we can always safely await it
            MDB.DNX.LabelingAnalysis.AutoSaveProm = $.Deferred(function(d){
                d.resolve();
            }).promise();
            
            var doSave = function(){
                var dirtyQuestions = getDirtyQuestions();
                
                if(!dirtyQuestions.length){
                    scheduleNextAutoSave();
                    return;
                }
                
                MDB.DNX.LabelingAnalysis.IsAutoSaving = true;
                
                MDB.DNX.LabelingAnalysis.AutoSaveProm = $.Deferred(function(d){
                    var formSelector = MDB.DNX.LabelingAnalysis.GetFormSelector();
                    
                    $.ajax({
                        url: MDB.DNX.LabelingAnalysis.AutoSaveEndpoint,
                        data: formSelector.serialize(),
                        method: 'POST'
                    }).done(function(){
                        //Only mark input as unchanged on successful save
                        dirtyQuestions.removeClass('dirty');
                    })
                    .always(function(){
                        MDB.DNX.LabelingAnalysis.IsAutoSaving = false;
                        
                        scheduleNextAutoSave();
                        d.resolve();
                    }); 
                }).promise();
            };
            
            var scheduleNextAutoSave = function(){
                MDB.DNX.LabelingAnalysis.AutoSaveIntervalId = setTimeout(doSave, MDB.DNX.LabelingAnalysis.AutoSaveInterval);
            };

            scheduleNextAutoSave();
        },
        GetFormSelector: function(){
            return $('#labeling-analysis-form');
        },
        SetFormTarget: function(url) {
            MDB.DNX.LabelingAnalysis.GetFormSelector().attr('action', url);
        },
        ToggleCustomerQuestionBlocks: function(selector, display) {
            var block = selector.is('.sentence-analysis') ? selector : selector.closest('.sentence-analysis');
            
            block.find('.customer-questions').toggleClass('hidden', !display);
        },
        ToggleSentenceCompletion: function(selector, completed){
            //When a sentence is marked as completed, the block itself should clearly display so
            var block = selector.is('.sentence-analysis') ? selector : selector.closest('.sentence-analysis');
            
            block.toggleClass('completed', completed);
        },
        ToggleSentenceTranscriptUnsure: function(selector, enabled){
            //When a sentence is marked as 'unsure', it should be clearly marked as such by means of a different color
            var block = selector.is('.sentence-analysis') ? selector : selector.closest('.sentence-analysis');
            
            block.toggleClass('correction-unsure', enabled);
        },
        ToggleSentenceBlock: function(selector, enabled) {
            //All but RemoveTranscript (which should trigger this action)/SentenceNo (sentence identifier) should be disabled
            //RemoveTranscript implies the transcript can't be analyzed
            
            var block = selector.is('.sentence-analysis') ? selector : selector.closest('.sentence-analysis');
            var affectedControls = block.find('input:not([name$="RemoveTranscript"],[name$="SentenceNo"]),textarea,select');
            
            //Disable form elements, and clearly mark labels as inactive by adding a 'text-muted' class
            affectedControls.attr('disabled', enabled ? null : true);
            affectedControls.closest('.labeling-question').find('label').toggleClass('text-muted', !enabled);
            
            MDB.DNX.LabelingAnalysis.ToggleSliders(block, enabled);
        },
        ToggleSliders: function(selector, enabled){
            var isReadOnly = MDB.DNX.LabelingAnalysis.IsMarkedReadOnly();
            
            selector = selector.is('[data-display-type="Slider"]') ? selector : selector.find('[data-display-type="Slider"]');

            selector.each(function(){
                var slider = $(this).data('slider');

                if(!enabled){
                    var sliderMax = slider.options.max;
                    
                    //In readOnly mode sliders should not have their value reset
                    if(!isReadOnly){
                        //Reset slider to a 'neutral' position
                        slider.setValue(Math.ceil(sliderMax / 2));    
                    }
                    
                    slider.disable();
                }
                else {
                    slider.enable();
                }
            });
        },
        FormatSliderLabel: function(option){
            //options = { display: ..., displayName: ..., name: ... }
            
            var wrapper = document.createElement('div');
            var element = document.createElement('span');
            
            element.innerText = option.display;
            
            if(option.displayName){
                element.setAttribute('title', option.displayName);
            }

            //By default our emojis are a tad on the small side
            element.setAttribute('style', 'font-size: 21px');

            // element.setAttribute('title', 'brioche');
            wrapper.appendChild(element);
            
            return wrapper.innerHTML;
        },
        RenderSentenceCollapseSwitch: function(selector){
            //Ensure our value is 'displayed'
            selector
                .attr('checked', 'checked')
                .val(true);
            
            MDB.bootstrapSwitchPill(selector, {
                onColor: '#0376B5',
                offColor: '#FFFFFF',
                
                onSwitchChange: function(){
                    var hide = !$(this).is(':checked')
                        , sentences = $('.sentence-analysis-container');

                    if(hide) sentences.slideUp();
                    else sentences.slideDown();
                }
            });
        },
        RenderBoundsTooltips: function(selector){
            selector.each(function(){
                var $this = $(this)
                    , tooltip = $this.data('tooltip');
                
                //Use the DOM api to properly escape our tooltip content
                var wrapper = document.createElement('div');
                var tooltipElement = document.createElement('span');

                tooltipElement.innerText = tooltip;
                
                //Arrays should be displayed as lists
                if(Array.isArray(tooltip)){
                    tooltipElement = document.createElement('ul');

                    tooltip.forEach(function(text){
                        var li = document.createElement('li');
                        li.innerText = text;
                        tooltipElement.appendChild(li);
                    });
                }

                wrapper.appendChild(tooltipElement);
                
                $this.popover({
                    trigger: 'hover',
                    content: wrapper.innerHTML,
                    html: true
                });
            });
        },
        RenderIntensitySliders: function(selector, combo) {
            var sliderQuestionId = combo.Slider
                , dropdownQuestionId = combo.Dropdown;
            
            var sentenceBlocks = $(selector).closest('.sentence-analysis');
            
            sentenceBlocks.each(function(){
                /*
                    Option metadata:
                    {
                        "intensityNotApplicable" (optional): true/false,
                        "icons": {
                            ...
                        }
                    }
                 */
                
                var sentenceBlock = $(this)
                    , sliderQuestion = sentenceBlock.find('[data-question-id="' + sliderQuestionId + '"]')
                    , dropdownQuestion = sentenceBlock.find('[data-question-id="' + dropdownQuestionId + '"]')
                    , optionMetadata = dropdownQuestion.find('option:selected').data('metadata')
                    , optionIcons = optionMetadata.icons || {}
                    , sliderNotApplicable = optionMetadata.intensityNotApplicable === true;

                var config = {
                    min: MDB.DNX.LabelingAnalysis.SentenceSliderMin,
                    max: MDB.DNX.LabelingAnalysis.SentenceSliderMax,

                    lock_to_ticks: false,
                    tooltip_position: 'top',
                    ticks: [],
                    ticks_positions: [],
                    ticks_labels: []
                };
                
                //icon key = percentage/value to show it at
                //slider requires our tick values to be numbers
                //if not its length goes haywire
                (Object.keys(optionIcons) || []).map(function(pctStr){
                    return parseInt(pctStr);
                }).forEach(function(pct){
                    config.ticks.push(pct);
                    config.ticks_positions.push(pct);
                    config.ticks_labels.push(MDB.DNX.LabelingAnalysis.FormatSliderLabel(optionIcons[pct]));
                });
                
                MDB.DNX.LabelingAnalysis.RenderSliders(sliderQuestion, config);
                
                if(sliderNotApplicable) {
                    MDB.DNX.LabelingAnalysis.ToggleSliders(sliderQuestion, false);    
                }
            });

            //Creating a single selector for all created label containers should be the fastest way to go
            var sliderQuestionContainers = sentenceBlocks.find('.labeling-question:has([data-question-id="' + sliderQuestionId + '"])');
            MDB.DNX.LabelingAnalysis.MoveSliderTickLabelsToTop(sliderQuestionContainers);
        },
        RenderSentenceSliders: function(selector){
            MDB.DNX.LabelingAnalysis.RenderSliders(selector, {
                min: MDB.DNX.LabelingAnalysis.SentenceSliderMin,
                max: MDB.DNX.LabelingAnalysis.SentenceSliderMax,
            });
        },
        RenderPersonalityTraitSliders: function(selector){
            MDB.DNX.LabelingAnalysis.RenderSliders(selector, {
                min: MDB.DNX.LabelingAnalysis.PersonalityTraitSliderMin,
                max: MDB.DNX.LabelingAnalysis.PersonalityTraitSliderMax,
                
                ticks: _.range(MDB.DNX.LabelingAnalysis.PersonalityTraitSliderMin, MDB.DNX.LabelingAnalysis.PersonalityTraitSliderMax + 1)
            });
            
            MDB.DNX.LabelingAnalysis.MarkSliderTicksClickable(selector.closest('.labeling-question'));
        },
        RenderSliders: function(selector, baseConfig){
            selector = $(selector);
            
            var configKeys = Object.keys(baseConfig);
            
            var getConfigCopy = function(){
                return configKeys.reduce(function(sliderConfig, key){
                    sliderConfig[key] = baseConfig[key];
                    return sliderConfig;
                }, {});
            };
            
            //We have to loop over each item in order to properly set our initial value
            selector.each(function(){
                var $this = $(this)
                    , currentSlider = $this.data('slider')
                    , sliderConfig = getConfigCopy(); //Since we'll be altering the object, we'll always want a copy
                
                //Slider needs to be destroyed in order to alter settings
                if(currentSlider){
                    currentSlider.destroy();
                }
                
                //Allow a value to be provided by the config, otherwise take the current element value
                if(!sliderConfig.hasOwnProperty('value')){
                    sliderConfig.value = parseInt(this.value);
                    
                    if(isNaN(sliderConfig.value)){
                        sliderConfig.value = 0;
                    }
                }

                sliderConfig.step = 1;
                
                $this.slider(sliderConfig);
                
                MDB.DNX.LabelingAnalysis.AddTrackingToSlider($this);
            });

            var sliderSelector = selector.closest('.labeling-question')
                .find('.slider');

            //An actual 'selection' does not apply to this module
            MDB.DNX.LabelingAnalysis.DisableSliderSelectionHighlight(sliderSelector);
            
            //Sliders take a set width by default
            //we want our sliders to take near full container width
            //there still needs to be some space for our 'dirty' marker
            sliderSelector
                .css({ 'max-width': '100%', 'width': '95%', 'left': '5%' });
            
            //We don't utilize the tooltips provided by our slider
            //they do however, still take up space, blocking users from hovering
            //over our tick labels and seeing the value of their 'title' attributes
            sliderSelector
                .find('.tooltip.top')
                .hide();
        },
        DisableSliderSelectionHighlight: function(selector){
            //Track -> selected part
            selector.find('.slider-selection').hide();
            
            //Ticks -> force even 'selected' ticks to not change color
            selector.find('.slider-tick').css({
                'background-image': 'linear-gradient(to bottom, #f9f9f9 0%, #f5f5f5 100%)',
                'opacity': '1'
            });
        },
        MarkSliderTicksClickable: function(selector){
            selector.find('.slider-tick').css('cursor', 'pointer');
        },
        MoveSliderTickLabelsToTop: function(selector){
            //Slider does not provide the ability to provide tick labels at the top by default
            //Move labels to top manually
            selector.find('.slider-tick-label')
                .css('top', '-35px');
        },
        AddTrackingToSlider: function(selector){
            //Change causes rapid fire events on drag, we only care about the end result
            //thus using slideStop should suffice
            selector.data('slider').on('slideStop', function(){
                MDB.DNX.LabelingAnalysis.LogToSnowplow(selector);
            });
        },
        AddTrackingToDropdowns: function(selector){
            selector.on('change', function(){
                MDB.DNX.LabelingAnalysis.LogToSnowplow($(this));
            });
        },
        ExtractSnowplowData: function(inputSelector){
            /* 
                when a value changes in a dropdown or slider changes we want to send an event with some custom information 
                (sentence nr, dropdown/slider label, dropdown/slider value) 
            */
            
            /*
                {
                    displayType: String,
                    questionId: Int,
                    
                    value: String (when dropdown)/Int (when slider),
                    
                    sentenceNr: Int (Only available for sentence questions),
                    valueLabel: String (Only available for dropdowns)
                }
             */
            
            var questionContainer = inputSelector.closest('.labeling-question')
                , sentenceBlock = questionContainer.closest('.sentence-analysis')
                , questionId = questionContainer.find('[name$="QuestionId"]').val()
                , displayType = inputSelector.data('displayType')
                , selectedValue = inputSelector.val();
            
            var data = {
                displayType: displayType,
                questionId: parseInt(questionId),
                value: selectedValue
            };
            
            //Personality traits don't have a sentence number associated with them
            if(sentenceBlock.length){
                var sentenceNr = sentenceBlock.find('[name$="SentenceNo"]').val();
                data.sentenceNr = parseInt(sentenceNr);
            }
            
            if(displayType === MDB.DNX.LabelingAnalysis.QuestionDisplayTypes.Dropdown){
                //text() might return padding around the text
                var valueLabel = inputSelector.find('[value="' + inputSelector.val() + '"]').text();
                data.valueLabel = valueLabel.trim();
            }
            
            if(displayType  === MDB.DNX.LabelingAnalysis.QuestionDisplayTypes.Slider){
                //Sliders always contain integer values
                data.value = parseInt(data.value);
            }
            
            return data;
        },
        LogToSnowplow: function(inputSelector){
            //Prior to startup; prevent logging from going through
            if(!MDB.DNX.LabelingAnalysis.SnowplowTrackingEnabled){
                return;
            }
            
            var data = MDB.DNX.LabelingAnalysis.ExtractSnowplowData(inputSelector);
            
            //Only invoke our fnGetData once we are sure tracking is enabled
            MDB.Snowplow.trackSelfDescribingEvent(
                MDB.DNX.LabelingAnalysis.SnowplowEventSchema,
                data
            );
        }
    });
})(jQuery);